export const REVIEW_TITLE_LIMIT = 100;
export const REVIEW_BODY_MIN = 75;
export const REVIEW_BODY_MAX = 3000;
export const PRIVATE_REVIEW_BODY_MAX = 4000;
export const POSITIVE_RATING_MINIMUM = 4;